export const urls = {
  reservation: 'https://docs.google.com/forms/d/e/1FAIpQLSfJZ2e6ZOgEZWwFN7w9yEPWs6X4Sa7fjiyIPssjGxyR-4zRWA/viewform',
  takeawayOrder: 'https://my-site-106771-103558.square.site/',
}
